import React from "react";
import { Box, LinearProgress } from "@material-ui/core";
import "./progress-indicator.component.scoped.scss";

interface ProgressIndicatorProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  isWaitingForAnswer: boolean;
  answeredQuestionsCount?: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentQuestionIndex,
  totalQuestions,
  isWaitingForAnswer,
  answeredQuestionsCount
}) => {
  // Use answeredQuestionsCount as base when available, otherwise use currentQuestionIndex
  const baseProgress = answeredQuestionsCount !== undefined ? answeredQuestionsCount : currentQuestionIndex;
  
  // Only add 1 if we don't have answeredQuestionsCount and we're not waiting for answer
  const shouldAddOne = (answeredQuestionsCount === undefined && !isWaitingForAnswer) ? 1 : 0;
  
  const progressPercentage = Math.min(
    ((baseProgress + shouldAddOne) / totalQuestions) * 100,
    100
  );

  return (
    <Box className="progress-section">
      <LinearProgress
        variant="determinate"
        value={progressPercentage}
        className="progress-bar"
      />
    </Box>
  );
};

export default ProgressIndicator; 